import { Alert, AlertTitle, Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { groupGateIssues } from '../../shared/publish-view'
import { messageIdForCode } from '../../shared/rejection-messages'
import type { GateIssue } from '../../shared/types'

export interface GateResultsProps {
  issues: GateIssue[]
}

export default function GateResults({ issues }: GateResultsProps) {
  const { formatMessage } = useIntl()
  const groups = groupGateIssues(issues)

  if (!groups.length) {
    return null
  }

  return (
    <Alert severity="error">
      <AlertTitle>
        {formatMessage({ id: 'avatarStudio.publish.gateFailed' })}
      </AlertTitle>
      <Stack spacing={1.5} sx={{ mt: 1 }}>
        {groups.map((group) => (
          <Box key={group.code}>
            <Typography variant="body2">
              {formatMessage({ id: messageIdForCode(group.code) })}
            </Typography>
            {group.items.map((item) => (
              <Typography
                key={item}
                variant="caption"
                component="div"
                translate="no"
                sx={{ pl: 2, color: 'text.secondary' }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        ))}
      </Stack>
      <Typography variant="body2" sx={{ mt: 1.5 }}>
        {formatMessage({ id: 'avatarStudio.publish.fixThenStage' })}
      </Typography>
    </Alert>
  )
}
